import React, { useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { getGiftCardRequest, processGiftCard } from "../../../api/trade";
import { Table } from "antd";
import { giftCardRequestColumn } from "../../customers/column";
import { showErrorToast, showSuccessToast } from "../../../utils/toast";
import DeclineGiftCardTrade from "./DeclineGiftCardTrade";
import GiftCardRequestDetail from "./GiftCardRequestDetail";

const GiftcardRequest = () => {
  const queryClient = useQueryClient();
  const [id, setId] = useState("");
  const [open, setOpen] = useState(false);

  const [openDetail, setOpenDetail] = useState(false);
  const [singleData, setSingleData] = useState({});
  const [permissions, setPermissions] = useState(null);

  useEffect(() => {
    const ls = localStorage.getItem("permissions");
    try {
      const parsedLs = JSON.parse(ls);
      setPermissions(parsedLs);
    } catch (error) {}
  }, []);

  const getModulePermission = (module, section) => {
    const pers = permissions?.find(
      (per) =>
        String(per?.module?.toLowerCase()) === String(module.toLowerCase()),
    )?.permissions;
    return pers ? pers[section] : false;
  };

  const { data, isLoading } = useQuery(["gift-card-request"], () =>
    getGiftCardRequest(),
  );

  const mutation = useMutation(processGiftCard, {
    onSuccess: () => {
      queryClient.invalidateQueries("gift-card-request");
      queryClient.invalidateQueries("giftcard-history");
      showSuccessToast("Action successful");
    },
    onError: (e) => {
      showErrorToast(e.message);
      setAccepting(false);
    },
  });

  const handleRowClick = (record) => {
    setSingleData(record || {});
    setOpenDetail(true);
  };

  return (
    <div>
      <GiftCardRequestDetail
        open={openDetail}
        setOpen={setOpenDetail}
        record={singleData}
      />
      <Table
        loading={isLoading}
        dataSource={data?.requests || []}
        columns={giftCardRequestColumn(
          mutation,
          setId,
          setOpen,
          setOpenDetail,
          setSingleData,
          getModulePermission,
        )}
        rowClassName="cursor-pointer hover:bg-gray-50"
        // onRow={(record) => {
        //   return {
        //     onClick: () => handleRowClick(record),
        //   };
        // }}
      />

      {open && <DeclineGiftCardTrade id={id} open={open} setOpen={setOpen} />}
    </div>
  );
};

export default GiftcardRequest;
